import {
    SET_UPDATE_FUNC
} from 'constants/ActionTypes';

export const setUpdateFunc = (func) => {
        return {
        type: SET_UPDATE_FUNC,
        payload: {func}
        };
};